
    <div class="header-container-save-grid">
        <mat-icon class="save-grid-header-icon">grid_on</mat-icon>
        <h1 mat-dialog-title class="save-grid-header">Save Grid to Sample Group</h1>
    </div>



<form [formGroup]="saveGridForm">
    <div class="save-grid-input-container">
        <mat-form-field class="save-grid-input" appearance="outline">
            <mat-label>Sample Group Name</mat-label>
            <input matInput formControlName="gridName">
            @if (saveGridForm.get('gridName').invalid) {
                <mat-error class="error-notice">
                    Required* - Sample Group Name
                </mat-error>
            }
        </mat-form-field>
    </div>
</form>

<div mat-dialog-actions>
    <button mat-flat-button (click)="cancel()" type="button" class="cancel-save-grid" [disabled]="isSaving">Cancel</button>
    <button class="save-grid-save-btn" mat-flat-button (click)="saveGrid()" [disabled]="isSaving">Save</button>
</div>
